import './patientOrderHistoryComponent.scss';

import React, {useEffect, useCallback, useState} from 'react';
import {CommonService} from "../../../../shared/services";
import PatientOrderHistoryTableComponent from "./patient-order-history-list/patientOrderHistoryTable";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import SearchComponent from "../../../../shared/components/search/SearchComponent";

interface PatientOrderHistoryComponentProps {
    patientId: any;
}

const PatientOrderHistoryComponent = (props: PatientOrderHistoryComponentProps) => {
    const {patientId} = props;
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);

    const [filterData, setFilterData] = useState<any>({
        search: '',
        patientId: patientId,
    });

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
        CommonService.setQueryParam('search', value);
    }, []);

    useEffect(() => {
        if (queryParamData) {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: queryParamData.search || '',
            }));
        }
    }, [queryParamData]);

        return (
            <div className="patient-order-history-list-component component">
                <div className={"screen-content-wrapper"}>
                    <div className="page-data-wrapper">
                        <div className="page-options">
                            <div className="page-search">
                                <SearchComponent
                                    label={"Search Test Order"}
                                    id="search_input"
                                    placeholder={""}
                                    value={filterData.search}
                                    onChange={handleSearch}
                                />
                            </div>
                            <div className="page-extra-options">
                                {/*<Link to={CommonService._routeConfig.TestOrderCreateRoute()}>*/}
                                {/*    <ButtonComponent*/}
                                {/*        type="button"*/}
                                {/*        color={"secondary"}*/}
                                {/*        variant={"contained"}*/}
                                {/*        id="add_test_order_btn"*/}
                                {/*        startIcon={<AddIcon/>}*/}
                                {/*    >*/}
                                {/*        New Test Order*/}
                                {/*    </ButtonComponent>*/}
                                {/*</Link>*/}
                            </div>
                        </div>
                        <div className="page-data-wrapper">
                            <PatientOrderHistoryTableComponent filterdata={filterData}/>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

;

export default PatientOrderHistoryComponent;

